var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("ims-avatar size-" + _vm.size),style:(("background-image:url(" + _vm.src + ")"))},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }